<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-3 hidden-xs column-left" id="column-left">
        <div class="column-block">
          <div class="columnblock-title">Categories</div>
          <div class="category_block">
            <ul class="box-category treeview-list treeview">
              <li><a href="#/category/electronics">Electronics</a></li>
              <li><a href="#/category/mobile">Mobile</a></li>
              <li><a href="#/category/fashion">Fashion</a></li>
              <li><a href="#/category/games">Games</a></li>
              <li><a href="#/category/sports">Sports</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-9" id="content">
        <div class="row">
          <div class="col-sm-6">
            <div class="well">
              <h2>LOGIN</h2>
              <div class="form-group">
                <label for="input-contactkey" class="control-label"
                  >Contact Key</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="input-contactkey"
                  placeholder=""
                  value=""
                  name=""
                  v-model="contactKey"
                />
              </div>
              <input
                type="submit"
                class="btn btn-primary"
                value="Login"
                @click="login()"
                v-if="!isShowButton"
              />
              <input
                type="submit"
                class="btn btn-primary"
                value="Update"
                @click="update()"
                v-if="isShowButton"
              />
              <input
                type="submit"
                class="btn btn-primary"
                value="Logout"
                @click="logout()"
                v-if="isShowButton"
              />
            </div>
            {{ message }}
          </div>
        </div>
        <div>
          <div class="well" v-if="dengage_sdk_enabled">
            <span style="display: flex;">Information</span>
            <div style="margin: 15px;">
              <div style="display: flex; padding-bottom: 15px;">
                <span style="font-weight: bold; margin-right:10px">Device Id:</span>
                <span id="deviceId" style="word-break: break-all;">{{ deviceId }}</span>
              </div>
              <div style="display: flex; padding-bottom: 15px;">
                <span style="font-weight: bold; margin-right:10px">Contact Key:</span>
                <span id="contactKey" style="word-break: break-all;">{{ contactKey }}</span>
              </div>
              <div style="display: flex; padding-bottom: 15px;">
                <span style="font-weight: bold; margin-right:10px">Token:</span>
                <span id="token" style="word-break: break-all;">{{ token }}</span>
              </div>
              <div style="word-break: break-all;">
                <span style="font-weight: bold; margin-right:10px">WEB Subscription:</span>
                <span id="webSubscription" style="word-break: break-all;">{{ wpSubscription }}</span>
              </div>
              <div style="margin-top:15px;font-weight: bold;">
               This site is connected to the {{ dengage_connected_env }} platform. Web Push Type: {{ dengage_webpush_type }}
              </div>
            </div>
          </div>
          <div class="well" v-else>
            Dengage SDK is not enabled for this site!!!
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactKey: "",
      deviceId: "",
      isShowButton: false,
      message: "",
      token: "",
      wpSubscription: "",
      dengage_webpush_type: dengage_webpush_type,
      dengage_connected_env: dengage_connected_env,
      dengage_sdk_enabled: dengage_sdk_enabled,
    };
  },
  methods: {
    login() {
      console.log(this.contactKey, " : contact_key");
      console.log(this.deviceId, " : device_id");

      dengage("setContactKey", this.contactKey);

      /*dataLayer.push({
        event: 'dengage_login',
        dengage_contact_key: this.contactKey,
      });*/
      localStorage.setItem('contact_key', this.contactKey);
      //collector.loginAction(true, '', this.contactKey);

      window.sgfLayer = {
        user: {
          step: "signin",
          username: this.contactKey
        },
        common: {
          userId: this.contactKey ? this.contactKey : this.deviceId
        }
      };

      this.message = "Login is successful.";
      setTimeout(this.updateInformation, 100);
    },
    logout() {
      window.sgfLayer = {
        user: {
          step: "signout",
          username: this.contactKey
        },
        common: {
          userId: this.contactKey ? this.contactKey : this.deviceId
        }
      };

      dengage("setContactKey", "");

      /*dataLayer.push({
        event: 'dengage_logout',
        dengage_contact_key: '',
      });*/
      localStorage.setItem('contact_key', '');
      //collector.loginAction(true, '', '');
      setTimeout(this.updateInformation, 100);
    },
    update() {
      console.log(this.contactKey, " : contact_key");
      console.log(this.deviceId, " : device_id");

      dengage("setContactKey", this.contactKey);

      /*dataLayer.push({
        event: 'dengage_login',
        dengage_contact_key: this.contactKey,
      });*/
      localStorage.setItem('contact_key', this.contactKey);
      //collector.loginAction(true, '', this.contactKey);

      window.sgfLayer = {
        user: {
          step: "update",
          username: this.contactKey
        },
        common: {
          userId: this.contactKey ? this.contactKey : this.deviceId
        }
      };

      this.message = "Update is successful.";
      setTimeout(this.updateInformation, 100);
    },
    updateInformation() {
      var $this = this;
      //dengage("getContactKey", function(contact_key) {
        var contact_key = localStorage.getItem('contact_key');
        if (contact_key) {
          $this.isShowButton = true;
        }
        $this.contactKey = contact_key;
      //});

      dengage("getDeviceId", function(device_id) {
        $this.deviceId = device_id;
      });
      dengage('getToken', function(token) {
        $this.token = token || '---';
        var sub = localStorage.getItem('dengage_webpush_sub');
        $this.wpSubscription = sub || '---';
      });
    },
  },
  mounted() {

    dengage('setNavigation', {name: 'login'});
    this.updateInformation();		

    //collector.loginPage(localStorage.getItem('contact_key'))
  }

};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Login.vue